"use client";

import Image from "next/image";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Section from "../Section";
const styles = new Proxy({"Healthcare":"Healthcare-e5e4e","healthIntro":"healthIntro-e5e4e","bodyModeling":"bodyModeling-e5e4e","cardLeft":"cardLeft-e5e4e","iframeContainer":"iframeContainer-e5e4e"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./usecasetabs.scss";*/

interface ResolvedTab {
  eventKey: string;
  title: string;
  description: string;
  image: { url: string; width: number; height: number };
  imgAltText: string;
  imgWidth?: number;
  imgHeight?: number;
}

interface UseCasesClientProps {
  title?: string;
  tabs: ResolvedTab[];
}

const UseCasesClient: React.FC<UseCasesClientProps> = ({ title, tabs }) => {
  return (
    <div className={`${styles.Healthcare} use-case-tabs`}>
      <Section
        title={
          title ||
          "Let us turn your motion data into quantifiable digital biomarkers"
        }
        className="pb-5"
        maxWidth={1080}
      >
        <Tabs defaultActiveKey={tabs[0].eventKey || 0} className="pt-5">
          {tabs.map((tab, idx) => (
            <Tab
              eventKey={tab.eventKey || idx}
              title={tab.title}
              key={tab.title || idx}
            >
              <Image
                src={tab.image.url}
                alt={tab.imgAltText}
                width={tab.imgWidth || tab.image.width}
                height={tab.imgHeight || tab.image.height}
              />
              <p className="text-center-mobile">{tab.description}</p>
            </Tab>
          ))}
        </Tabs>
      </Section>
    </div>
  );
};

export default UseCasesClient;
